import { create } from 'zustand';

interface AppLoadedStore {
  status: boolean;
  setAppLoaded: () => void;
}

export const useAppLoadedStore = create<AppLoadedStore>((set) => ({
  status: false,
  setAppLoaded: () => set({ status: true }),
}));
